import React, { useEffect, useState } from "react";
import { Tabs } from "../components/Tabs/tabs";
import { Table } from "../childrens/logsPage/Table";
import { Paginate } from "../components/Paginate/paginate";
import { Search } from "../components/search/search";
import { useStore } from "../store/useStore";
import '../styles/historical.css'

function LogsPage() {
    const { logsData } = useStore()
    const [filterData, setFilterData] = React.useState(logsData)
    const options = ['All', 'Rack Count', 'Access Control', 'Rack', 'Data Hall', 'Site']
    const [selected, setSelected] = useState('All')
    const [tabData, setTabData] = useState([])
    const [currentPageData, setCurrentPageData] = useState([])

    useEffect(() => {
        setFilterData(logsData)
        setTabData(logsData)
    }, [logsData])

    function actionTabs(val) {
        switch (val) {
            case 'Rack Count':
                setTabData(logsData.filter(el => el.action.includes('Rack Count')))
                setFilterData(logsData.filter(el => el.action.includes('Rack Count')))
                break;
            case 'Access Control':
                setTabData(logsData.filter(el => el.action.includes('Access Control')))
                setFilterData(logsData.filter(el => el.action.includes('Access Control')))
                break;
            case 'Data Hall':
                setTabData(logsData.filter(el => el.action.includes('Data Hall')))
                setFilterData(logsData.filter(el => el.action.includes('Data Hall')))
                break;
            case 'Site':
                setTabData(logsData.filter(el => el.action.includes('Site')))
                setFilterData(logsData.filter(el => el.action.includes('Site')))
                break;
            case 'Rack':
                setTabData(logsData.filter(el => el.action.includes('Rack') && el.action.includes('updated')))
                setFilterData(logsData.filter(el => el.action.includes('Rack') && el.action.includes('updated')))
                break;
            default:
                setFilterData(logsData)
                setTabData(logsData)
                break;
        }
        setSelected(val)
    }

    return (
        <section className="body-list-principal">
            <div style={{ justifyContent: 'space-between' }} className="body-list-header">
                <h1>Logs</h1>
            </div>
            <div className="body-list-principal_content_filter">
                <Tabs style={{ width: '60%' }} options={options} onClick={actionTabs} selected={selected} />
                <Search initialData={tabData} set={setFilterData} placeholder={`Search`} className='body-list-notas_content_filter_search' style={{ width: '40%' }} />
            </div>
            <Table arr={currentPageData} />
            <Paginate arr={filterData} set={setCurrentPageData} />
        </section>

    )
}

export default LogsPage
